export default __webpack_public_path__ + "Maestro.059581bf.svg";